import { render, staticRenderFns } from "./exercicio.vue?vue&type=template&id=4743668a&"
import script from "./exercicio.vue?vue&type=script&lang=js&"
export * from "./exercicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QBtn,QTooltip,QCircularProgress} from 'quasar'
component.options.components = Object.assign({QPage,QCard,QCardSection,QBtn,QTooltip,QCircularProgress}, component.options.components || {})
